// One colour per part (module). Hex values mirror styles/tokens.css (--part-<id>*), which CSS should use;
// this map is for canvas drawing and inline CSS variables. Unknown modules fall back to the generic cobalt.
export type PartColor = { hue: string; ink: string; soft: string; onNavy: string };

export const PART_COLORS: Record<string, PartColor> = {
  "line-endings": { hue: "#14b8c8", ink: "#127689", soft: "#e3f6f8", onNavy: "#14b8c8" },
  "json-drop-fields": { hue: "#ff6a4d", ink: "#ad4f44", soft: "#ffedea", onNavy: "#ff6a4d" },
  "json-sort-keys": { hue: "#7a5cff", ink: "#6952de", soft: "#efebff", onNavy: "#8a70ff" },
  "trim-lines": { hue: "#ffb020", ink: "#8c6829", soft: "#fff6e4", onNavy: "#ffb020" },
  "ascii-lower": { hue: "#ff5c9e", ink: "#ad467a", soft: "#ffebf3", onNavy: "#ff5c9e" },
  "decimal-scale": { hue: "#1fbf7a", ink: "#187a5c", soft: "#e4f7ef", onNavy: "#1fbf7a" },
  generic: { hue: "#224ddb", ink: "#224ddb", soft: "#e4eafb", onNavy: "#8fa8ff" },
};

export function partColor(moduleId: string | undefined | null): PartColor {
  return (moduleId && PART_COLORS[moduleId]) || PART_COLORS.generic!;
}

/** CSS custom properties for an element that belongs to one part: --part, --part-ink, --part-soft. */
export function partVars(moduleId: string | undefined | null): Record<string, string> {
  const id = moduleId && PART_COLORS[moduleId] ? moduleId : "generic";
  return {
    "--part": `var(--part-${id})`,
    "--part-ink": `var(--part-${id}-ink)`,
    "--part-soft": `var(--part-${id}-soft)`,
    "--part-on-navy": `var(--part-${id}-on-navy)`,
  };
}
